"use client";
import { usePrescriptionContext } from "@/src/provider";
import { FmCheckbox, FmPicker } from "@/ui-component";
import React, { useMemo, useState } from "react";
import RxTitle from "../RxTitle";
import PDHelp from "./PDHelp";
import stl from "./pdHelp.module.scss";
import variable from "@/src/styles/variables.module.scss";
import classnames from "classnames";
import formStl from "@/src/productDetails/Rx/RxForm/rxForm.module.scss";
import { IErrorList } from "@/src/productDetails/Rx/RxForm";
import { useTranslation } from "@/src/i18n/client";
interface IProps {
    selectData: Record<string, number[]>;
    errors: IErrorList;
    onChange?: () => void;
}
type PDType = "pd" | "left_pd" | "right_pd";
const PD: React.FC<IProps> = (props) => {
    const { errors } = props;
    const { t } = useTranslation("lens");
    const [activeData, setPrescription, setActiveData] = usePrescriptionContext(
        (state) => [
            state.activeData,
            state.setPrescription,
            state.setActiveData,
        ],
    );

    const [pickerOpen, setPickerOpen] = useState<Record<PDType, boolean>>({
        pd: false,
        left_pd: false,
        right_pd: false,
    });

    const defaultOption: Record<string, any> = useMemo(() => {
        return {
            pd: { value: t("lens:Rx.SeletPd"), label: t("lens:Rx.SeletPd") },

            left_pd: { value: t("lens:Rx.LeftPD"), label: t("lens:Rx.LeftPD") },
            right_pd: {
                value: t("lens:Rx.RightPD"),
                label: t("lens:Rx.RightPD"),
            },
        };
    }, [t]);
    const aixsData = useMemo(() => {
        const validData: Record<string, any> = {};
        for (let key of ["pd", "left_pd", "right_pd"]) {
            const temp = (props.selectData?.[key]).map(
                (item: string | number) => {
                    return {
                        label: item,
                        value: item,
                    };
                },
            );
            temp.unshift(defaultOption[key]);
            validData[key] = temp;
        }
        return validData;
    }, [defaultOption, props.selectData]);

    return (
        <div className={stl["pd-container"]}>
            <RxTitle
                title={`${t("lens:Rx.PD")}`}
                details={`(${t("lens:Rx.PupillaryDistance")})`}
            >
                <PDHelp />
            </RxTitle>
            <div className={stl["wrapper-container"]}>
                <FmPicker
                    borderColor={variable.main}
                    error={props.errors.PDError.trim().length > 0}
                    errorPosition="bottom"
                    name={activeData.twoPD ? "left_pd" : "pd"}
                    inputClassName={stl["picker-wrapper"]}
                    dataSource={aixsData[activeData.twoPD ? "left_pd" : "pd"]}
                    open={pickerOpen[activeData.twoPD ? "left_pd" : "pd"]}
                    confirm={"confirm"}
                    cancel={"cancel"}
                    inputClasses={{
                        inputCount: stl["input-content"],
                        outline: stl["outline-div"],
                    }}
                    onChange={(open, value) => {
                        setPickerOpen((prev) => {
                            prev[activeData.twoPD ? "left_pd" : "pd"] = open;
                            prev[activeData.twoPD ? "pd" : "left_pd"] = false; // 其他的取反（即关闭）
                            return prev;
                        });
                        setPrescription({
                            [activeData.twoPD ? "left_pd" : "pd"]:
                                value as string,
                        });
                        props.onChange?.();
                    }}
                    defaultValue={
                        defaultOption[activeData.twoPD ? "left_pd" : "pd"].value
                    }
                    value={
                        activeData.twoPD
                            ? activeData.prescription.left_pd ??
                              defaultOption["left_pd"].value
                            : activeData.prescription.pd ??
                              defaultOption["pd"].value
                    }
                    classes={{
                        icon: stl["icon"],
                        root: classnames(stl["input-content-pd"], {
                            [stl["pd-of-left"]]: activeData.twoPD,
                        }),
                    }}
                ></FmPicker>
                {activeData.twoPD && (
                    <FmPicker
                        error={props.errors.PDError.trim().length > 0}
                        errorPosition="bottom"
                        borderColor={variable.main}
                        name={"right_pd"}
                        inputClassName={stl["picker-wrapper"]}
                        dataSource={aixsData["right_pd"]}
                        open={pickerOpen["right_pd"]}
                        confirm={"confirm"}
                        cancel={"cancel"}
                        onChange={(open, value) => {
                            setPickerOpen((prev) => {
                                prev["right_pd"] = open;
                                return prev;
                            });
                            setPrescription({
                                ["right_pd"]: value as number,
                            });
                            props.onChange?.();
                        }}
                        defaultValue={defaultOption["right_pd"].label}
                        value={
                            activeData.prescription.right_pd ??
                            defaultOption["right_pd"].value
                        }
                        classes={{
                            icon: stl["icon"],
                            root: classnames(stl["input-content-pd"], {
                                [stl["pd-of-right"]]: activeData.twoPD,
                            }),
                        }}
                    ></FmPicker>
                )}
            </div>
            <FmCheckbox
                formControlClassName={stl["checked-container"]}
                values={activeData.twoPD ? "twoPD" : ""}
                dataSource={[
                    {
                        label: t("lens:TwoPDNumbers"),
                        value: "twoPD",
                        labelClassName: classnames(
                            stl["label"],
                            stl["label-classnames"],
                        ),
                        checkboxName: "twoPD",
                    },
                ]}
                checkboxClassName={stl["checkbox-class"]}
                onChange={(value) => {
                    setPickerOpen((prev: Record<PDType, boolean>) => {
                        for (let key in prev) {
                            prev[key as PDType] = false;
                        }
                        return prev;
                    });
                    setActiveData({ twoPD: !!value });
                }}
            />
            {errors.PDError && (
                <div className={classnames(formStl["error"], stl["pd-error"])}>
                    {errors.PDError}
                </div>
            )}
        </div>
    );
};

export default PD;
